
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies-form",
      function () {
        return require("private-next-pages/companies-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies-form"])
      });
    }
  